/* Dandy — mobile product-card swipe: keep the dot indicator in sync with the
   image the shopper swiped to. Scroll events don't bubble, so one capture-phase
   listener covers every card on the page (grids are re-rendered nowhere, but
   delegation also survives any future dynamic sections). */
(function () {
  try {
    if (!window.matchMedia('(hover: none), (max-width: 768px)').matches) return;
    document.addEventListener('scroll', function (e) {
      var media = e.target;
      if (!media || !media.classList || !media.classList.contains('product-card__media')) return;
      window.requestAnimationFrame(function () {
        var card = media.closest('.product-card');
        if (!card) return;
        var dots = card.querySelectorAll('.product-card__dots i');
        if (!dots.length) return;
        var idx = Math.round(media.scrollLeft / Math.max(1, media.clientWidth));
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === idx);
        }
      });
    }, { capture: true, passive: true });
  } catch (err) { /* a dot indicator must never break the page */ }
})();